module.exports = __webpack_public_path__ + "static/img/icon_home_counter_bg.94ca73d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_home_counter_bg.svg
// module id = k1dN
// module chunks = 10